import React from 'react';
import type { MessageDescriptor } from '@atlassian/jira-intl';
import { TemplateTypes } from '../../../../common/constants/project';
import { JSWKanbanIllustration } from './kanban';
import { JSWScrumIllustration } from './scrum';

export type Props = {
	isTmp: boolean;
	projectName: string;
	projectKey: string;
	projectTemplate?: string | null;
	teamManagedIllustrationFooter: MessageDescriptor;
	companyManagedIllustrationFooter: MessageDescriptor;
};

export const IllustrationJSW = ({
	projectTemplate,
	teamManagedIllustrationFooter,
	companyManagedIllustrationFooter,
	...props
}: Props) => {
	switch (projectTemplate) {
		case TemplateTypes.SCRUM:
			return (
				<JSWScrumIllustration
					{...props}
					teamManagedIllustrationFooter={teamManagedIllustrationFooter}
					companyManagedIllustrationFooter={companyManagedIllustrationFooter}
				/>
			);
		default:
			return (
				<JSWKanbanIllustration
					{...props}
					teamManagedIllustrationFooter={teamManagedIllustrationFooter}
					companyManagedIllustrationFooter={companyManagedIllustrationFooter}
				/>
			);
	}
};
